import React from 'react'
import type { PresentationSection } from 'paintscout'

import { ButtonOption } from '../../components'
import makeRowHandlers from '../../util/makeRowHandlers'

import AddIcon from '@material-ui/icons/Add'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

interface DocumentsOptionsProps {
  section: PresentationSection
  handleOptionFieldChange: (field: string, value: any) => void
}

function DocumentsOptions(props: DocumentsOptionsProps) {
  const { section, handleOptionFieldChange } = props
  const { rows } = section.fields

  const { handleAddRow, handleRemoveLastRow } = makeRowHandlers({
    rows,
    newRow: { title: '', content: '', image: null },
    handleOptionFieldChange
  })

  const options = [
    {
      Component: (
        <ButtonOption
          label={'Documents'}
          buttons={[
            { icon: <AddIcon />, onClick: handleAddRow },
            ...(rows?.length ? [{ icon: <DeleteOutlineIcon />, onClick: handleRemoveLastRow }] : [])
          ]}
        />
      ),
      tab: 'content'
    }
  ]

  return options
}

export default DocumentsOptions
